(function ($) {
  // ----- jQuery Message 插件定义 (仿 Element Plus 风格) -----
  var Message = function (options) {
    // 支持直接传入字符串
    if (typeof options === "string") {
      options = { message: options };
    }
    this.settings = $.extend({}, $.fn.message.defaults, options);
    this.init();
  };

  // 实例方法
  Message.prototype = {
    init: function () {
      this.createMessage();
      this.bindEvents();
      this.showMessage();
    },

    createMessage: function () {
      // 生成唯一ID (用于动画清理)
      var id = "msg-" + Math.random().toString(36).substring(2, 10);

      // 类型映射图标 (Element Plus 常用图标)
      var iconMap = {
        // info: "fa-circle-info",
        // primary: "fa-circle-check",
        success: "icon-check-circle-filled",
        warning: "icon-error-circle-filled",
        error: "icon-close-circle-filled",
        danger: "icon-close-circle-filled", // 兼容 danger 映射为 error 图标
      };
      var type = this.settings.type;
      var iconClass = iconMap[type];

      // 构建消息元素 (完全模仿 element 消息结构)
      var $msg = $(
        '<div class="custom-message" style=" background: ' +
          this.getBackgroundColor(type) +
          '; ">' +
          '<i class="icon iconfont ' +
          iconClass +
          '" style="color: ' +
          this.getIconColor(type) +
          ';"></i>' +
          '<span class="custom-message__content">' +
          this.settings.message +
          "</span>" +
          (this.settings.showClose
            ? '<i class="iconfont icon-close custom-message__closeBtn"></i>'
            : "") +
          "</div>",
      );

      $msg.attr("data-message-id", id);
      $msg.css("opacity", 0); // 初始透明，用于动画

      // 如果内容是HTML，则作为html插入
      if (this.settings.dangerouslyUseHTMLString) {
        $msg.find(".custom-message__content").html(this.settings.message);
      }

      this.$el = $msg;
      this.id = id;
    },

    getBackgroundColor: function (type) {
      var map = {
        // info: "#909399",
        // primary: "#409eff",
        success: "#EBF9F3",
        warning: "#fdf6ec",
        error: "#FCEDED",
        danger: "#FCEDED",
      };
      return map[type] || map["info"];
    },

    getIconColor: function (type) {
      var map = {
        // info: "#909399",
        // primary: "#409eff",
        success: "#00AD65",
        warning: "#F68A38",
        error: "#E03333",
        danger: "#E03333",
      };
      return map[type] || map["info"];
    },

    bindEvents: function () {
      var self = this;
      // 手动关闭按钮
      this.$el.find(".custom-message__closeBtn").on("click", function (e) {
        e.stopPropagation();
        self.close();
      });

      // 如果允许点击关闭（非按钮区域也可配置关闭，但element默认无此行为，我们遵循点击内容不关）
      // 但是element plus点击消息不会关闭，我们保持一样，只通过按钮或自动关闭
    },

    showMessage: function () {
      var self = this;
      var $container = $("#customMessageContainer");

      // 如果容器不存在则创建
      if ($container.length === 0) {
        $container = $('<div id="customMessageContainer" class="custom-message-container"></div>');
        $("body").append($container);
      }

      // 限制最大显示数量 (element plus 默认是同时展示5个)
      var max = this.settings.maxStack || 5;
      var $currentMessages = $container.children(".custom-message");
      if ($currentMessages.length >= max) {
        // 移除最早的一条（即容器中的第一个）
        $currentMessages.first().remove();
      }

      // 插入到容器
      $container.append(this.$el);

      // 强制重排后添加透明度动画
      setTimeout(function () {
        self.$el.css("opacity", 1);
      }, 20);

      // 如果不是0（永不自动关闭），则启动定时器
      if (this.settings.duration !== 0) {
        this.timer = setTimeout(function () {
          self.close();
        }, this.settings.duration);
      }
    },

    close: function () {
      var self = this;

      // 清除定时器
      if (this.timer) {
        clearTimeout(this.timer);
      }

      // 淡出动画 (与element类似)
      this.$el.animate({ opacity: 0, marginTop: "-20px", height: "toggle" }, 200, function () {
        self.$el.remove();
        // 清理容器如果为空（可选，保留容器也行）
        var $container = $("#customMessageContainer");
        if ($container.children().length === 0) {
          // 为了性能可以不删，但整洁起见可保留空容器
        }
      });
    },
  };

  // 挂载到jQuery对象上 (核心插件方法)
  $.message = function (options) {
    return new Message(options);
  };

  // 快捷方法 (仿 element plus)
  // $.message.info = function (msg, duration, options) {
  //   return $.message($.extend({ message: msg, type: "info", duration: duration || 3500 }, options));
  // };
  // $.message.primary = function (msg, duration, options) {
  //   return $.message(
  //     $.extend({ message: msg, type: "primary", duration: duration || 3500 }, options),
  //   );
  // };
  $.message.success = function (msg, duration, options) {
    return $.message(
      $.extend({ message: msg, type: "success", duration: duration || 3500 }, options),
    );
  };
  $.message.warning = function (msg, duration, options) {
    return $.message(
      $.extend({ message: msg, type: "warning", duration: duration || 3500 }, options),
    );
  };
  $.message.error = function (msg, duration, options) {
    return $.message(
      $.extend({ message: msg, type: "error", duration: duration || 3500 }, options),
    );
  };
  $.message.danger = $.message.error; // 别名

  // 默认配置
  $.fn.message = function (options) {
    // 为了完整性，提供$.fn调用方式（其实很少用）
    return $.message(options);
  };
  $.fn.message.defaults = {
    message: "", // 消息文字
    type: "info", // info / primary / success / warning / error
    duration: 3500, // 显示时间，0为不自动关闭
    showClose: false, // 是否显示关闭按钮
    maxStack: 5, // 最大同时展示数量
    dangerouslyUseHTMLString: false, // 是否将 message 属性作为 HTML 片段处理
    customClass: "", // 可选自定义类，本例简化
  };
})(jQuery);
